import { Board, Position } from '../types.ts';

export const isValidSquare = (row: number, col: number): boolean => 
  row >= 0 && row < 8 && col >= 0 && col < 8;

export const cloneBoard = (board: Board): Board => 
  board.map(row => [...row]);

export const positionToAlgebraic = (position: Position): string => {
  const [row, col] = position;
  const file = String.fromCharCode(97 + col); // a-h
  const rank = (8 - row).toString(); // 1-8
  return `${file}${rank}`;
};